export const formConf = {
    size: "mini",
    labelPosition: "top",
    labelWidth: 100,
    formRules: "rules",
    gutter: 20,
    disabled: false,
    span: 24,
    title: "",
}
export const ValueType = {
    string: "String",
    object: "Object",
    array: "Array",
    number: "Number",
    date: "Date",
    user: "User",
    dept: "Dept",
    byApi: "ByApi",
    dateRange: "DateRange",
    boolean: "Boolean",
    select: "Select",
    cascade: "Cascade",
    calculateDay: "CalculateDay",
}
// 布局型组件 【左面板】
export const layoutComponents = [
    {
        typeId: "CARD",
        __config__: {
            label: "卡片容器",
            labelWidth: null,
            showLabel: false,
            changeTag: false,
            tag: "Card",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.array,
        },
        props: {
            title: '卡片标题',
            shadow: 'always',
            rows: [
                {
                    "clearable": true,
                    "prefix-icon": "",
                    "__config__": {
                        "formId": 1746679568118,
                        "defaultValue": "1",
                        "document": "https://element.eleme.cn/#/zh-CN/component/input",
                        "showRegList": true,
                        "label": "单行文本",
                        "showLabel": true,
                        "required": false,
                        "renderKey": "17466795681181746679568118",
                        "layout": "colFormItem",
                        "displayType": true,
                        "tagIcon": "input",
                        "changeTag": true,
                        "valueType": "String",
                        "variable": "",
                        "tag": "el-input",
                        "regList": [],
                        "span": 24
                    },
                    "readonly": false,
                    "valueType": "String",
                    "__vModel__": "field1746679568118",
                    "typeId": "INPUT",
                    "style": {
                        "width": "100%"
                    },
                    "disabled": false,
                    "placeholder": "请输入单行文本",
                    "show-word-limit": false,
                    "__slot__": {
                        "prepend": "",
                        "append": ""
                    },
                    "suffix-icon": ""
                }
            ]
        }
    },
    {
        typeId: "TABS",
        __config__: {
            label: "标签面板",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "Tabs",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.array,
        },
        props: {
            defaultIndex: 1,
            tabPosition: 'left', // top/right/bottom/left
            type: '', //card/border-card
            tabs: [
                {
                    label: '标签1',
                    index: 0,
                    rows: []
                },
                {
                    label: '标签2',
                    index: 1,
                    rows: []
                }
            ]
        }
    },
    {
        typeId: "COLLAPSE",
        __config__: {
            label: "折叠面板",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "Collapse",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.array,
        },
        props: {
            accordion: false,
            tabs: [
                {
                    label: '标签1',
                    rows: []
                },
                {
                    label: '标签2',
                    rows: []
                }
            ]
        }
    },
    {
        typeId: "GROUP_TITLE",
        __config__: {
            label: "分组标题",
            labelWidth: null,
            showLabel: false,
            changeTag: false,
            tag: "GroupTitle",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.object,
        },
        props: {
            title: '分组标题',
            position: 'left'
        }
    }
]

// 辅助型组件 【左面板】
export const assistComponents = [
    {
        // 组件的自定义配置
        typeId: "INPUT",
        __config__: {
            label: "单行文本",
            labelWidth: null,
            showLabel: true,
            changeTag: true,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "",
        "suffix-icon": "",
        maxlength: null,
        "show-word-limit": false,
        readonly: false,
        disabled: false,
        valueType: ValueType.string,
    },
    {
        typeId: "TEXTAREA",
        __config__: {
            label: "多行文本",
            labelWidth: null,
            showLabel: true,
            tag: "el-input",
            tagIcon: "textarea",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: true,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.string,
        },
        type: "textarea",
        placeholder: "请输入",
        autosize: {
            minRows: 4,
            maxRows: 4,
        },
        style: { width: "100%" },
        maxlength: null,
        "show-word-limit": false,
        readonly: false,
        disabled: false,
        valueType: ValueType.string,
    },
    {
        // 组件的自定义配置
        typeId: "PASSWORD",
        __config__: {
            label: "密码",
            labelWidth: null,
            showLabel: true,
            changeTag: true,
            tag: "el-input",
            tagIcon: "password",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "请输入",
        "show-password": true,
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "",
        "suffix-icon": "",
        maxlength: null,
        "show-word-limit": false,
        readonly: false,
        disabled: false,
        valueType: ValueType.string,
    },
    {
        typeId: "NUMBER_INPUT",
        __config__: {
            label: "计数器",
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            tag: "el-input-number",
            tagIcon: "number",
            defaultValue: undefined,
            displayType: true,
            span: 24,
            layout: "colFormItem",
            required: false,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input-number",
            valueType: ValueType.number,
        },
        placeholder: "请输入",
        min: undefined,
        max: undefined,
        step: 1,
        "step-strictly": false,
        precision: undefined,
        "controls-position": "",
        disabled: false,
    },
    {
        typeId: "TINYMCE",
        __config__: {
            label: "富文本框",
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            tag: "tinymce",
            tagIcon: "rich-text",
            defaultValue: null,
            span: 24,
            layout: "colFormItem",
            displayType: true,
            showRegList: false,
            required: false,
            regList: [],
            document: "http://tinymce.ax-z.cn",
            valueType: ValueType.string,
        },
        placeholder: "请输入",
        height: 0,
        branding: false,
    },
    {
        typeId: "DESC_TEXT",
        __config__: {
            label: "文字描述",
            defaultValue: "描述内容。。。",
            displayType: true,
            showDefaultValue: true,
            showRequired: false,
            showClearable: false,
            showRegList: false,
            showLabel: true,
            tag: "desc-text",
            tagIcon: "text",
            layout: "colFormItem",
            span: 24,
            required: false,
            regList: [],
            changeTag: false,
            valueType: ValueType.string,
        },
        color: "",
        textAlign: "left",
        style: { width: "100%" },
    },
    {
        typeId: "DIVIDER",
        __config__: {
            label: "分割线",
            defaultValue: "",
            displayType: true,
            showLabel: false,
            showDefaultValue: false,
            showRequired: false,
            showClearable: false,
            showRegList: false,
            tag: "el-divider",
            tagIcon: "divider",
            layout: "colFormItem",
            span: 24,
            required: false,
            regList: [],
            changeTag: false,
            valueType: ValueType.object,
        },
        color: undefined,
        style: { width: "100%" },
    },
    {
        typeId: "SIGN_PAD",
        __config__: {
            label: "手写签名",
            defaultValue: "",
            showLabel: true,
            showDefaultValue: false,
            displayType: true,
            showrequired: false,
            showClearable: false,
            showRegList: false,
            tag: "sign-pad",
            tagIcon: "sign-pad",
            layout: "colFormItem",
            span: 24,
            required: false,
            regList: [],
            changeTag: false,
            valueType: ValueType.object,
        },
        color: "#000000",
        style: { width: "100%" },
        action: "/formProjectPublic/upload/imageSingleUploadToImageBase64",
    },
    {
        typeId: "Duration",
        __config__: {
            label: "时长",
            defaultValue: undefined,
            showDefaultValue: false,
            showLabel: true,
            displayType: true,
            showrequired: false,
            showClearable: false,
            showRegList: false,
            tag: "Duration",
            tagIcon: "Duration",
            layout: "colFormItem",
            span: 24,
            required: false,
            regList: [],
            changeTag: false,
            valueType: ValueType.object,
        },
        placeholder: "请输入审批时限",
    },
    {
        typeId: "ENCRYPTINPUT",
        __config__: {
            label: "信息脱敏",
            defaultValue: undefined,
            showDefaultValue: false,
            showLabel: true,
            displayType: true,
            showrequired: false,
            showClearable: false,
            showRegList: false,
            tag: "EncryptInput",
            tagIcon: "input",
            layout: "colFormItem",
            span: 24,
            required: false,
            regList: [],
            changeTag: false,
            valueType: ValueType.string,
        },
        placeholder: "",
        props: {
            rule: 'center', // front, after, center，
            word: 4
        }
    }
]

export const selectComponents = [
    {
        typeId: "OrgTreeSelect",
        __config__: {
            label: "部门",
            showLabel: true,
            defaultValue: undefined,
            showDefaultValue: true,
            labelWidth: null,
            tag: "OrgTreeSelect",
            tagIcon: "select",
            layout: "colFormItem",
            displayType: true,
            span: 24,
            required: false,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/select",
            valueType: ValueType.dept,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        clearable: true,
        disabled: false,
        filterable: false,
        multiple: true,
        max: 99999,
        limits: false,
    },
    {
        typeId: "org-user-picker",
        __config__: {
            label: "用户",
            showLabel: true,
            defaultValue: undefined,
            showDefaultValue: false,
            labelWidth: null,
            tag: "org-user-picker",
            tagIcon: "select",
            layout: "colFormItem",
            displayType: true,
            span: 24,
            required: false,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/select",
            valueType: ValueType.user,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        disabled: false,
        filterable: false,
        multiple: true,
        max: 1,
    },
    {
        typeId: "ByDictSelect",
        __config__: {
            label: "字典下拉框",
            showLabel: true,
            defaultValue: undefined,
            showDefaultValue: true,
            labelWidth: null,
            tag: "ByDictSelect",
            tagIcon: "select",
            layout: "colFormItem",
            displayType: true,
            span: 24,
            required: false,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/dict",
            valueType: ValueType.select,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        disabled: false,
        filterable: false,
        multiple: false,
        dataBind: undefined,
        max: 1,
        appId: undefined,
        apiUrl: "",
    },
    {
        typeId: "SELECT_V2",
        __config__: {
            label: "下拉选择",
            showLabel: true,
            defaultValue: undefined,
            showDefaultValue: true,
            labelWidth: null,
            tag: "SelectV2",
            tagIcon: "select",
            layout: "colFormItem",
            displayType: true,
            span: 24,
            required: false,
            showRegList: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/select",
            valueType: ValueType.select,
        },
        options: [
            {
                label: "选项一",
                value: "选项一",
            },
        ],
        placeholder: "请选择",
        style: { width: "100%" },
        clearable: true,
        disabled: false,
        filterable: false,
        multiple: false,
    },
    {
        typeId: "CASCADER_V2",
        __config__: {
            label: "级联选择",
            url: "https://www.fastmock.site/mock/f8d7a54fb1e60561e2f720d5a810009d/fg/cascaderList",
            method: "get",
            dataKey: "list",
            showLabel: true,
            displayType: true,
            showDefaultValue: false,
            labelWidth: null,
            tag: "DataCascader",
            tagIcon: "cascader",
            layout: "colFormItem",
            defaultValue: [],
            dataType: "static",
            span: 24,
            required: false,
            showRegList: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/cascader",
            valueType: ValueType.cascade,
        },
        options: [],
        placeholder: "请选择",
        style: { width: "100%" },
        props: {
            props: {
                multiple: false,
                label: "label",
                value: "value",
                children: "children",
            },
        },
        "show-all-levels": true,
        disabled: false,
        clearable: true,
        filterable: false,
        separator: "/",
        multiple: false,
        isData: false,
        unit: "分",
    },
    {
        typeId: "RADIO",
        __config__: {
            label: "单选框组",
            labelWidth: null,
            showLabel: true,
            showRegList: false,
            displayType: true,
            tag: "el-radio-group",
            tagIcon: "radio",
            changeTag: true,
            showDefaultValue: false,
            defaultValue: undefined,
            layout: "colFormItem",
            span: 24,
            optionType: "default",
            regList: [],
            required: false,
            border: false,
            document: "https://element.eleme.cn/#/zh-CN/component/radio",
            valueType: ValueType.string,
        },
        __slot__: {
            options: [
                {
                    label: "选项一",
                    value: "选项一",
                },
            ],
        },
        style: {},
        size: "medium",
        disabled: false,
        valueType: ValueType.string,
    },
    {
        typeId: "CHECKBOX",
        __config__: {
            label: "多选框组",
            tag: "el-checkbox-group",
            tagIcon: "checkbox",
            defaultValue: [],
            showDefaultValue: false,
            span: 24,
            showLabel: true,
            showRegList: false,
            displayType: true,
            labelWidth: null,
            layout: "colFormItem",
            optionType: "default",
            required: false,
            regList: [],
            changeTag: true,
            border: false,
            document: "https://element.eleme.cn/#/zh-CN/component/checkbox",
            valueType: ValueType.array,
        },
        __slot__: {
            options: [
                {
                    label: "选项一",
                    value: "选项一",
                },
            ],
        },
        style: {},
        size: "medium",
        min: null,
        max: null,
        disabled: false,
        valueType: ValueType.array,
    },
    {
        typeId: "SWITCH",
        __config__: {
            label: "开关",
            tag: "el-switch",
            tagIcon: "switch",
            defaultValue: false,
            showDefaultValue: false,
            displayType: true,
            span: 24,
            showRegList: false,
            showLabel: true,
            labelWidth: null,
            layout: "colFormItem",
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/switch",
            valueType: ValueType.boolean,
        },
        style: {},
        disabled: false,
        "active-text": "",
        "inactive-text": "",
        "active-color": null,
        "inactive-color": null,
        "active-value": true,
        "inactive-value": false,
    },
    {
        typeId: "SLIDER",
        __config__: {
            label: "滑块",
            tag: "el-slider",
            tagIcon: "slider",
            defaultValue: null,
            showDefaultValue: false,
            displayType: true,
            showRegList: false,
            span: 24,
            showLabel: true,
            layout: "colFormItem",
            labelWidth: null,
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/slider",
            valueType: ValueType.number,
        },
        disabled: false,
        min: 0,
        max: 100,
        step: 1,
        "show-stops": false,
        range: false,
    },
    {
        typeId: "TIME",
        __config__: {
            label: "时间选择",
            tag: "el-time-picker",
            tagIcon: "time",
            defaultValue: null,
            showDefaultValue: false,
            displayType: true,
            span: 24,
            showLabel: true,
            showRegList: false,
            layout: "colFormItem",
            labelWidth: null,
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/time-picker",
            valueType: ValueType.date,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        disabled: false,
        clearable: true,
        "picker-options": {
            selectableRange: "00:00:00-23:59:59",
        },
        format: "HH:mm:ss",
        "value-format": "HH:mm:ss",
    },
    {
        typeId: "TIME_RANGE",
        __config__: {
            label: "时间范围",
            tag: "el-time-picker",
            tagIcon: "time-range",
            showDefaultValue: false,
            displayType: true,
            span: 24,
            showLabel: true,
            showRegList: false,
            labelWidth: null,
            layout: "colFormItem",
            defaultValue: null,
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/time-picker",
            valueType: ValueType.dateRange,
        },
        style: { width: "100%" },
        disabled: false,
        clearable: true,
        "is-range": true,
        "range-separator": "至",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        format: "HH:mm:ss",
        "value-format": "HH:mm:ss",
    },
    {
        typeId: "DATE",
        __config__: {
            label: "日期选择",
            tag: "el-date-picker",
            tagIcon: "date",
            showDefaultValue: false,
            defaultValue: null,
            showRegList: false,
            displayType: true,
            showLabel: true,
            labelWidth: null,
            span: 24,
            layout: "colFormItem",
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/date-picker",
            valueType: ValueType.date,
        },
        placeholder: "请选择",
        type: "date",
        style: { width: "100%" },
        disabled: false,
        clearable: true,
        format: "yyyy-MM-dd",
        "value-format": "yyyy-MM-dd",
        readonly: false,
    },
    {
        typeId: "DATE_RANGE",
        __config__: {
            label: "日期范围",
            tag: "el-date-picker",
            tagIcon: "date-range",
            defaultValue: null,
            showDefaultValue: false,
            displayType: true,
            showRegList: false,
            span: 24,
            showLabel: true,
            labelWidth: null,
            required: false,
            layout: "colFormItem",
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/date-picker",
            valueType: ValueType.dateRange,
        },
        style: { width: "100%" },
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        disabled: false,
        clearable: true,
        format: "yyyy-MM-dd",
        "value-format": "yyyy-MM-dd",
        readonly: false,
    },
    {
        typeId: "RATE",
        __config__: {
            label: "评分",
            tag: "el-rate",
            tagIcon: "rate",
            defaultValue: null,
            span: 24,
            showLabel: true,
            displayType: true,
            showRegList: false,
            labelWidth: null,
            layout: "colFormItem",
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/rate",
            valueType: ValueType.number,
        },
        style: {},
        max: 5,
        "allow-half": false,
        "show-text": false,
        "show-score": false,
        disabled: false,
    },
    {
        typeId: "COLOR",
        __config__: {
            label: "颜色选择",
            tag: "el-color-picker",
            tagIcon: "color",
            span: 24,
            defaultValue: null,
            showLabel: true,
            showRegList: false,
            displayType: true,
            labelWidth: null,
            layout: "colFormItem",
            required: false,
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/color-picker",
            valueType: ValueType.string,
        },
        "show-alpha": false,
        "color-format": "",
        disabled: false,
        size: "medium",
    },
    {
        typeId: "UPLOAD",
        __config__: {
            label: "上传",
            tag: "el-upload",
            tagIcon: "upload",
            layout: "colFormItem",
            showDefaultValue: false,
            defaultValue: null,
            displayType: true,
            showLabel: true,
            showRegList: false,
            labelWidth: null,
            required: false,
            span: 24,
            showTip: false,
            buttonText: "点击上传",
            regList: [],
            changeTag: true,
            fileSize: 10,
            sizeUnit: "MB",
            document: "https://element.eleme.cn/#/zh-CN/component/upload",
            valueType: ValueType.array,
        },
        __slot__: {
            "list-type": true,
        },
        action: process.env.VUE_APP_API_URL + "/file/upload",
        disabled: false,
        accept: null,
        showFileList: true,
        name: "file",
        "auto-upload": true,
        "list-type": "text",
        limit: 2,
        multiple: true,
    },
    {
        typeId: "Table_List",
        __config__: {
            label: "表格",
            tag: "table-list",
            tagIcon: "color",
            span: 24,
            defaultValue: null,
            showLabel: true,
            showRegList: false,
            displayType: true,
            labelWidth: null,
            layout: "colFormItem",
            regList: [],
            changeTag: true,
            document: "https://element.eleme.cn/#/zh-CN/component/color-picker",
            valueType: ValueType.array,
        },
        "show-alpha": false,
        "color-format": "",
        disabled: false,
        size: "medium",
        props: {
            maxSize: 0, // 最大条数，为0则不限制
            columns: [], // 列设置
        },
    },
    {
        typeId: "DATE_CALCULATE",
        __config__: {
            label: "日期天数",
            variable: "DateDays",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "DateDays",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.calculateDay,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        checks: ["工作日"],
        hasWorkTime: false,
        workingDate: ["08:00", "17:00"],
        unit: "day",
    },
    {
        typeId: "Feedback",
        __config__: {
            label: "反馈意见",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "Feedback",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.calculateDay,
        },
        placeholder: "请输入",
        style: { width: "100%" },
        options: [],
    },
]

export const systemComponents = [
    {
        typeId: "ID",
        __config__: {
            label: "主键",
            variable: "id",
            labelWidth: null,
            showLabel: true,
            changeTag: true,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: true,
        valueType: ValueType.string,
    },
    {
        typeId: "CREATE_BY",
        __config__: {
            label: "创建人",
            variable: "createByName",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: false,
        valueType: ValueType.string,
    },
    {
        typeId: "CREATE_TIME",
        __config__: {
            label: "创建时间",
            variable: "createTime",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-date-picker",
            tagIcon: "date",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/date",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.date,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: false,
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        valueType: ValueType.date,
    },
    {
        typeId: "UPDATE_BY",
        __config__: {
            label: "更新人",
            variable: "updateByName",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: false,
        valueType: ValueType.string,
    },
    {
        typeId: "UPDATE_TIME",
        __config__: {
            label: "更新时间",
            variable: "updateTime",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-date-picker",
            tagIcon: "date",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/date",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.date,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: false,
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        valueType: ValueType.date,
    },
    {
        typeId: "DEPT_CODE",
        __config__: {
            label: "创建人部门",
            variable: "deptName",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            showDefaultValue: false,
            showRequired: false,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "系统自动生成",
        style: { width: "100%" },
        clearable: undefined,
        readonly: true,
        disabled: false,
        valueType: ValueType.string,
    },
]

// 个人信息组件
export const personalInfoComponents = [
    {
        typeId: "INPUT",
        __config__: {
            label: "手机号",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            required: false,
            displayType: true,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            // 正则校验规则
            regList: [
                {
                    pattern: "/^1(3|4|5|6|7|8|9)\\d{9}$/",
                    message: "手机号格式错误",
                },
            ],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "el-icon-mobile",
        "suffix-icon": "",
        maxlength: 11,
        "show-word-limit": false,
        readonly: false,
        disabled: false,
    },
    {
        typeId: "INPUT",
        __config__: {
            label: "邮箱",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            required: false,
            layout: "colFormItem",
            span: 24,
            displayType: true,
            showRegList: false,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            // 正则校验规则
            regList: [
                {
                    pattern:
                        "/^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$/",
                    message: "邮箱格式错误",
                },
            ],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "el-icon-message",
        "suffix-icon": "",
        maxlength: 24,
        "show-word-limit": true,
        readonly: false,
        disabled: false,
    },
    {
        typeId: "INPUT",
        __config__: {
            label: "身份证",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            required: false,
            displayType: true,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            // 正则校验规则
            regList: [
                {
                    pattern:
                        "/(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)/",
                    message: "身份证格式错误",
                },
            ],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "el-icon-postcard",
        "suffix-icon": "",
        maxlength: 18,
        "show-word-limit": true,
        readonly: false,
        disabled: false,
    },
    {
        typeId: "PROVINCE_CITY",
        __config__: {
            label: "省市联动",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "province-city",
            tagIcon: "input",
            defaultValue: undefined,
            showDefaultValue: false,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.array,
        },
        placeholder: "请选择",
        style: { width: "100%" },
    },
    {
        typeId: "INPUT_MAP",
        __config__: {
            label: "地理位置",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "input-map",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.object,
        },
        placeholder: "请选择",
        style: { width: "100%" },
    },
    {
        typeId: "AREA_CODE",
        __config__: {
            label: "行政区划",
            labelWidth: null,
            showLabel: true,
            changeTag: false,
            tag: "AreaCode",
            tagIcon: "input",
            showDefaultValue: false,
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: false,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.cascade,
        },
        placeholder: "请选择",
        checkStrictly: 0,
        level: [3, 4],
        rangeArr: [["33", "3304"]],
        style: { width: "100%" },
    },
]

export const tasktComponents = [
    {
        typeId: "TREE_RELATION",
        __config__: {
            label: "父组件",
            variable: "parent",
            labelWidth: null,
            showLabel: true,
            tag: "TreeRelation",
            tagIcon: "select",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            showRegList: true,
            regList: [],
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            valueType: ValueType.object,
        },
        placeholder: "请选择",
        style: { width: "100%" },
        clearable: true,
        readonly: false,
        disabled: false,
        multiple: false,
        valueType: ValueType.string,
    },
    {
        typeId: "BIZ_RELATION",
        __config__: {
            label: "业务关联",
            labelWidth: null,
            showLabel: true,
            tag: "BizRelation",
            tagIcon: "select",
            defaultValue: undefined,
            displayType: true,
            enableRepeatSubmit: true,
            layout: "colFormItem",
            span: 24,
            document: "",
            required: false,
            showRequired: true,
            showRegList: true,
            // 正则校验规则
            regList: [],
            valueType: ValueType.object,
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "请选择",
        style: { width: "100%" },
        clearable: true,
        readonly: false,
        disabled: false,
        multiple: false,
        valueType: ValueType.string,
    },
    {
        typeId: "TASK_FORM",
        __config__: {
            label: "任务表单",
            variable: "taskForm",
            labelWidth: null,
            showLabel: true,
            tag: "el-input",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            enableRepeatSubmit: true,
            layout: "colFormItem",
            span: 24,
            document: "",
            showRegList: true,
            // 正则校验规则
            regList: [],
            valueType: ValueType.object,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "button",
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "",
        "suffix-icon": "",
        "show-word-limit": false,
        readonly: false,
        disabled: false,
        valueType: ValueType.string,
        previewBtnName: "去查看",
        fillBtnName: "去填报",
    },
    {
        typeId: "INPUT_COMPUTED",
        __config__: {
            label: "计算文本",
            labelWidth: null,
            showLabel: true,
            changeTag: true,
            tag: "InputComputed",
            tagIcon: "input",
            defaultValue: undefined,
            displayType: true,
            required: false,
            layout: "colFormItem",
            span: 24,
            document: "https://element.eleme.cn/#/zh-CN/component/input",
            showRegList: true,
            // 正则校验规则
            regList: [],
            valueType: ValueType.string,
        },
        // 组件的插槽属性
        __slot__: {
            prepend: "",
            append: "",
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: "请输入",
        style: { width: "100%" },
        clearable: true,
        "prefix-icon": "",
        "suffix-icon": "",
        maxlength: null,
        "show-word-limit": false,
        readonly: false,
        disabled: false,
        valueType: ValueType.string,
        calculationRules: {
            relation: [],
            operator: [
                {
                    label: '',
                    value: '',
                    operator: null,
                    next: null
                }
            ],
        }
    },
]